// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var Json_encode = require("@glennsl/bs-json/src/Json_encode.res.js");
var NpsLabel$ReactHooksTemplate = require("./NpsLabel.res.js");
var RandomId$ReactHooksTemplate = require("./RandomId.res.js");

function scaleValue(x) {
  if (x === "FiveScale") {
    return 5;
  } else {
    return 10;
  }
}

function decode(json) {
  return {
          text: Json_decode.withDefault("", (function (param) {
                  return Json_decode.field("text", Json_decode.string, param);
                }), json),
          description: Json_decode.withDefault("", (function (param) {
                  return Json_decode.field("description", Json_decode.string, param);
                }), json),
          label: NpsLabel$ReactHooksTemplate.make(Json_decode.withDefault("", (function (param) {
                      return Json_decode.field("left_label", Json_decode.string, param);
                    }), json), Json_decode.withDefault("", (function (param) {
                      return Json_decode.field("center_label", Json_decode.string, param);
                    }), json), Json_decode.withDefault("", (function (param) {
                      return Json_decode.field("right_label", Json_decode.string, param);
                    }), json)),
          veryUnlikely: Json_decode.withDefault("Very Unhappy!", (function (param) {
                  return Json_decode.field("very_unlikely", Json_decode.string, param);
                }), json),
          unlikely: Json_decode.withDefault("Unhappy!", (function (param) {
                  return Json_decode.field("unlikely", Json_decode.string, param);
                }), json),
          maybe: Json_decode.withDefault("It was ok!", (function (param) {
                  return Json_decode.field("maybe", Json_decode.string, param);
                }), json),
          likely: Json_decode.withDefault("Happy!", (function (param) {
                  return Json_decode.field("likely", Json_decode.string, param);
                }), json),
          extremelyLikely: Json_decode.withDefault("Super Happy!", (function (param) {
                  return Json_decode.field("extremely_likely", Json_decode.string, param);
                }), json)
        };
}

function empty(param) {
  return {
          id: undefined,
          uuid: RandomId$ReactHooksTemplate.generate(),
          text: "",
          scale: "TenScale",
          includeZero: true,
          description: "",
          label: NpsLabel$ReactHooksTemplate.empty(),
          representation: "Plain",
          componentType: undefined,
          configuration: undefined,
          translations: /* [] */0,
          answer: undefined
        };
}

function make(text, description, representation, label, uuid) {
  return {
          id: undefined,
          uuid: uuid,
          text: text,
          scale: "TenScale",
          includeZero: true,
          description: description,
          label: label,
          representation: representation,
          componentType: undefined,
          configuration: undefined,
          translations: /* [] */0,
          answer: undefined
        };
}

function setText(t, text) {
  return {
          id: t.id,
          uuid: t.uuid,
          text: text,
          scale: t.scale,
          includeZero: t.includeZero,
          description: t.description,
          label: t.label,
          representation: t.representation,
          componentType: t.componentType,
          configuration: t.configuration,
          translations: t.translations,
          answer: t.answer
        };
}

function setDescription(t, description) {
  return {
          id: t.id,
          uuid: t.uuid,
          text: t.text,
          scale: t.scale,
          includeZero: t.includeZero,
          description: description,
          label: t.label,
          representation: t.representation,
          componentType: t.componentType,
          configuration: t.configuration,
          translations: t.translations,
          answer: t.answer
        };
}

function setLabel(t, label) {
  return {
          id: t.id,
          uuid: t.uuid,
          text: t.text,
          scale: t.scale,
          includeZero: t.includeZero,
          description: t.description,
          label: label,
          representation: t.representation,
          componentType: t.componentType,
          configuration: t.configuration,
          translations: t.translations,
          answer: t.answer
        };
}

function setRepresentation(t, representation) {
  return {
          id: t.id,
          uuid: t.uuid,
          text: t.text,
          scale: t.scale,
          includeZero: t.includeZero,
          description: t.description,
          label: t.label,
          representation: representation,
          componentType: t.componentType,
          configuration: t.configuration,
          translations: t.translations,
          answer: t.answer
        };
}

function setIncludeZero(t, includeZero) {
  return {
          id: t.id,
          uuid: t.uuid,
          text: t.text,
          scale: t.scale,
          includeZero: includeZero,
          description: t.description,
          label: t.label,
          representation: t.representation,
          componentType: t.componentType,
          configuration: t.configuration,
          translations: t.translations,
          answer: t.answer
        };
}

function setScale(t, scale) {
  return {
          id: t.id,
          uuid: t.uuid,
          text: t.text,
          scale: scale,
          includeZero: t.includeZero,
          description: t.description,
          label: t.label,
          representation: t.representation,
          componentType: t.componentType,
          configuration: t.configuration,
          translations: t.translations,
          answer: t.answer
        };
}

function setComponentType(t, componentType) {
  return {
          id: t.id,
          uuid: t.uuid,
          text: t.text,
          scale: t.scale,
          includeZero: t.includeZero,
          description: t.description,
          label: t.label,
          representation: t.representation,
          componentType: componentType,
          configuration: t.configuration,
          translations: t.translations,
          answer: t.answer
        };
}

function setConfiguration(t, configuration) {
  return {
          id: t.id,
          uuid: t.uuid,
          text: t.text,
          scale: t.scale,
          includeZero: t.includeZero,
          description: t.description,
          label: t.label,
          representation: t.representation,
          componentType: t.componentType,
          configuration: configuration,
          translations: t.translations,
          answer: t.answer
        };
}

function componentType(t) {
  return t.componentType;
}

function configuration(t) {
  return t.configuration;
}

function $eq(t, x) {
  var y = t.answer;
  if (y !== undefined) {
    return y === x;
  } else {
    return false;
  }
}

function $great$eq(t, x) {
  var y = t.answer;
  if (y !== undefined) {
    return y >= x;
  } else {
    return false;
  }
}

function $less$eq(t, x) {
  var y = t.answer;
  if (y !== undefined) {
    return y <= x;
  } else {
    return false;
  }
}

function setAnswer(t, scale) {
  var match = t.answer;
  return {
          id: t.id,
          uuid: t.uuid,
          text: t.text,
          scale: t.scale,
          includeZero: t.includeZero,
          description: t.description,
          label: t.label,
          representation: t.representation,
          componentType: t.componentType,
          configuration: t.configuration,
          translations: t.translations,
          answer: match !== undefined && $eq(t, scale) ? undefined : scale
        };
}

function answered(t) {
  return t.answer !== undefined;
}

function id(t) {
  return t.id;
}

function uuid(t) {
  return t.uuid;
}

function duplicate(q) {
  return {
          id: undefined,
          uuid: RandomId$ReactHooksTemplate.generate(),
          text: q.text,
          scale: q.scale,
          includeZero: q.includeZero,
          description: q.description,
          label: q.label,
          representation: q.representation,
          componentType: q.componentType,
          configuration: q.configuration,
          translations: q.translations,
          answer: q.answer
        };
}

function text(t) {
  return t.text;
}

function getTextTranslation(t, language) {
  var translation = List.find_opt((function (param) {
          return param[0] === language;
        }), t.translations);
  if (translation !== undefined) {
    return translation[1].text;
  } else {
    return t.text;
  }
}

function description(t) {
  return t.description;
}

function getDescriptionTranslation(t, language) {
  var translation = List.find_opt((function (param) {
          return param[0] === language;
        }), t.translations);
  if (translation !== undefined) {
    return translation[1].description;
  } else {
    return t.description;
  }
}

function label(t) {
  return t.label;
}

function getLabelTranslation(t, language) {
  var translation = List.find_opt((function (param) {
          return param[0] === language;
        }), t.translations);
  if (translation !== undefined) {
    return translation[1].label;
  } else {
    return t.label;
  }
}

function getVeryUnlikelyTranslation(t, language) {
  var translation = List.find_opt((function (param) {
          return param[0] === language;
        }), t.translations);
  console.log("sdfsdf");
  console.log(translation);
  if (translation !== undefined) {
    return translation[1].veryUnlikely;
  } else {
    return "Very Unhappy!";
  }
}

function getUnlikelyTranslation(t, language) {
  var translation = List.find_opt((function (param) {
          return param[0] === language;
        }), t.translations);
  if (translation !== undefined) {
    return translation[1].unlikely;
  } else {
    return "Unhappy!";
  }
}

function getMaybeTranslation(t, language) {
  var translation = List.find_opt((function (param) {
          return param[0] === language;
        }), t.translations);
  if (translation !== undefined) {
    return translation[1].maybe;
  } else {
    return "It was ok!";
  }
}

function getLikelyTranslation(t, language) {
  var translation = List.find_opt((function (param) {
          return param[0] === language;
        }), t.translations);
  if (translation !== undefined) {
    return translation[1].likely;
  } else {
    return "Happy!";
  }
}

function getExtremelyLikelyTranslation(t, language) {
  var translation = List.find_opt((function (param) {
          return param[0] === language;
        }), t.translations);
  if (translation !== undefined) {
    return translation[1].extremelyLikely;
  } else {
    return "Super Happy!";
  }
}

function representation(t) {
  return t.representation;
}

function scale(t) {
  return t.scale;
}

function includeZero(t) {
  return t.includeZero;
}

function answer(t) {
  return t.answer;
}

function rating(t) {
  var answer = t.answer;
  if (answer !== undefined) {
    return answer;
  }
  
}

function answerToString(t) {
  var answer = t.answer;
  if (answer !== undefined) {
    return String(answer);
  } else {
    return "";
  }
}

function answerToInt(t) {
  var answer = t.answer;
  if (answer !== undefined) {
    return answer;
  }
  
}

function isAnswer(t, x) {
  var match = t.answer;
  if (match !== undefined) {
    return $eq(t, x);
  } else {
    return false;
  }
}

function answerRange(t) {
  var min = t.includeZero ? 0 : 1;
  var match = t.scale;
  var max;
  max = match === "FiveScale" ? 5 : 10;
  return [
          min,
          max
        ];
}

function isPromoter(t) {
  var match = answerToInt(t);
  if (match === undefined) {
    return false;
  }
  var match$1 = t.scale;
  if (match$1 === "FiveScale") {
    return $eq(t, 5);
  } else {
    return $great$eq(t, 9);
  }
}

function toJson(withAnswerOpt, t) {
  var withAnswer = withAnswerOpt !== undefined ? withAnswerOpt : false;
  var compType = t.componentType;
  var config = t.configuration;
  setComponentType(t, compType);
  setConfiguration(t, config);
  var encodeArray_0 = [
    "id",
    Json_encode.nullable((function (prim) {
            return prim;
          }), t.id)
  ];
  var encodeArray_1 = {
    hd: [
      "text",
      t.text
    ],
    tl: {
      hd: [
        "description",
        t.description
      ],
      tl: {
        hd: [
          "left_label",
          NpsLabel$ReactHooksTemplate.left(t.label)
        ],
        tl: {
          hd: [
            "center_label",
            NpsLabel$ReactHooksTemplate.center(t.label)
          ],
          tl: {
            hd: [
              "right_label",
              NpsLabel$ReactHooksTemplate.right(t.label)
            ],
            tl: {
              hd: [
                "start_from_zero",
                t.includeZero
              ],
              tl: {
                hd: [
                  "scale",
                  scaleValue(t.scale)
                ],
                tl: {
                  hd: [
                    "nps_component_type",
                    Json_encode.nullable((function (prim) {
                            return prim;
                          }), compType)
                  ],
                  tl: {
                    hd: [
                      "nps_representation_configuration",
                      Json_encode.nullable((function (a) {
                              return a;
                            }), config)
                    ],
                    tl: /* [] */0
                  }
                }
              }
            }
          }
        }
      }
    }
  };
  var encodeArray = {
    hd: encodeArray_0,
    tl: encodeArray_1
  };
  return Json_encode.object_(withAnswer ? ({
                  hd: [
                    "answer",
                    Belt_Option.getWithDefault(t.answer, -1)
                  ],
                  tl: encodeArray
                }) : encodeArray);
}

function decodeTranslation(json) {
  return [
          Json_decode.field("survey_language", (function (param) {
                  return Json_decode.field("name", Json_decode.string, param);
                }), json),
          Json_decode.field("key_string_mapping", decode, json)
        ];
}

function fromJson(json) {
  var match = Json_decode.field("category", (function (param) {
          return Json_decode.field("scale", (function (param) {
                        return Json_decode.withDefault(10, Json_decode.$$int, param);
                      }), param);
        }), json);
  return {
          id: Json_decode.field("category", (function (param) {
                  return Json_decode.field("id", (function (param) {
                                return Json_decode.optional(Json_decode.$$int, param);
                              }), param);
                }), json),
          uuid: Json_decode.field("uid", RandomId$ReactHooksTemplate.fromJson, json),
          text: Json_decode.field("category", (function (param) {
                  return Json_decode.field("text", Json_decode.string, param);
                }), json),
          scale: match !== 5 ? "TenScale" : "FiveScale",
          includeZero: Json_decode.field("category", (function (param) {
                  return Json_decode.field("start_from_zero", (function (param) {
                                return Json_decode.withDefault(true, Json_decode.bool, param);
                              }), param);
                }), json),
          description: Json_decode.field("category", (function (param) {
                  return Json_decode.field("description", Json_decode.string, param);
                }), json),
          label: NpsLabel$ReactHooksTemplate.make(Json_decode.field("category", (function (param) {
                      return Json_decode.field("left_label", Json_decode.string, param);
                    }), json), Json_decode.field("category", (function (param) {
                      return Json_decode.field("center_label", Json_decode.string, param);
                    }), json), Json_decode.field("category", (function (param) {
                      return Json_decode.field("right_label", Json_decode.string, param);
                    }), json)),
          representation: "Plain",
          componentType: Json_decode.field("category", (function (param) {
                  return Json_decode.optional((function (param) {
                                return Json_decode.field("nps_component_type", Json_decode.string, param);
                              }), param);
                }), json),
          configuration: Json_decode.field("category", (function (param) {
                  return Json_decode.optional((function (param) {
                                return Json_decode.field("nps_representation_configuration", (function (x) {
                                              return x;
                                            }), param);
                              }), param);
                }), json),
          translations: Json_decode.field("translations", (function (param) {
                  return Json_decode.list(decodeTranslation, param);
                }), json),
          answer: undefined
        };
}

var categoryType = "Nps";

exports.categoryType = categoryType;
exports.empty = empty;
exports.make = make;
exports.setText = setText;
exports.getTextTranslation = getTextTranslation;
exports.setDescription = setDescription;
exports.getDescriptionTranslation = getDescriptionTranslation;
exports.setLabel = setLabel;
exports.getLabelTranslation = getLabelTranslation;
exports.getVeryUnlikelyTranslation = getVeryUnlikelyTranslation;
exports.getUnlikelyTranslation = getUnlikelyTranslation;
exports.getMaybeTranslation = getMaybeTranslation;
exports.getLikelyTranslation = getLikelyTranslation;
exports.getExtremelyLikelyTranslation = getExtremelyLikelyTranslation;
exports.setRepresentation = setRepresentation;
exports.$eq = $eq;
exports.$great$eq = $great$eq;
exports.$less$eq = $less$eq;
exports.text = text;
exports.description = description;
exports.label = label;
exports.representation = representation;
exports.scale = scale;
exports.includeZero = includeZero;
exports.answer = answer;
exports.answered = answered;
exports.isAnswer = isAnswer;
exports.toJson = toJson;
exports.fromJson = fromJson;
exports.id = id;
exports.uuid = uuid;
exports.duplicate = duplicate;
exports.setAnswer = setAnswer;
exports.rating = rating;
exports.answerToString = answerToString;
exports.answerRange = answerRange;
exports.answerToInt = answerToInt;
exports.setIncludeZero = setIncludeZero;
exports.setScale = setScale;
exports.componentType = componentType;
exports.configuration = configuration;
exports.setComponentType = setComponentType;
exports.setConfiguration = setConfiguration;
exports.isPromoter = isPromoter;
/* RandomId-ReactHooksTemplate Not a pure module */
